<div class="header-bar">
  <div class="header-left">
    <div class="header-text">Geofences</div>
    <div class="divider"></div>
    <div class="search-box input-box">
      <svg-icon src="assets/svg/magnifier.svg"></svg-icon>

      <mat-form-field>
        <input matInput type="text" [formControl]="searchValueControl" />
      </mat-form-field>
    </div>
    <div class="divider"></div>
    <div class="filter">
      <button mat-button class="icon-btn" (click)="toggleFilterDialog()">
        <svg-icon src="assets/svg/filter.svg" svgClass="grey"></svg-icon>
      </button>
    </div>
  </div>
  <div class="header-center"></div>
  <div class="header-right">
    <button
      *ngIf="hasGeofencesWrite"
      mat-button
      color="lightGreen"
      (click)="createNewGeofence()"
    >
      Create New Geofence
    </button>
  </div>
</div>

<div class="geofences-list">
  <div class="container geofences-container">
    <div class="container-header no-bottom-border">
      <div class="text">Existing Geofences</div>
      <div class="options">
        <button
          *ngIf="hasGeofencesWrite"
          mat-icon-button
          [matMenuTriggerFor]="geofencesMenu"
        >
          <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
        </button>
        <mat-menu
          class="mat-menu-elaphant vertical-menu"
          #geofencesMenu="matMenu"
        >
          <button
            *ngIf="hasGeofencesWrite"
            class="icon-btn-w-text"
            mat-menu-item
            (click)="createNewGeofence()"
          >
            <svg-icon src="assets/svg/plus-circle-white.svg"></svg-icon>
            <span>Create New Geofence</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <div
      class="container-content"
      lhpeElementLoader
      #geofenceElementLoader="elementloader"
    >
      <table
        #geofencesTable
        mat-table
        [dataSource]="geofenceDataSource"
        matSort
      >
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>ID</th>
          <td mat-cell *matCellDef="let element">
            {{ element.id }}
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Geofence Name
          </th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>

        <ng-container matColumnDef="competitor">
          <th mat-header-cell *matHeaderCellDef>Competitor</th>
          <td mat-cell *matCellDef="let element">
            {{ element.competitor ? "Yes" : "No" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="options">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="options-cell">
            <button
              *ngIf="hasGeofencesWrite && hasGeofenceDetail"
              mat-button
              (click)="edit(element)"
              class="icon-btn"
            >
              <svg-icon
                src="assets/svg/pencil.svg"
                svgClass="lightBlue"
              ></svg-icon>
            </button>
            <div
              *ngIf="!(hasGeofencesWrite && hasGeofenceDetail)"
              class="empty-btn-space"
            ></div>
            <button
              *ngIf="hasGeofencesWrite"
              mat-button
              (click)="delete(element)"
              class="icon-btn"
            >
              <svg-icon
                src="assets/svg/trashcan.svg"
                [svgStyle]="{
                  'width.px': '15.25',
                  'height.px': '16.204'
                }"
                svgClass="lightBlue"
              ></svg-icon>
            </button>
            <div *ngIf="!hasGeofencesWrite" class="empty-btn-space"></div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="perPage" (page)="onPageChange($event)"></mat-paginator>
    </div>
  </div>
</div>
